export const BirdNestIcon = ({
  width = 400,
  height = 400,
  fill = "#231F20",
  eyeFill = "#EFEFEA",
}: {
  width?: number;
  height?: number;
  fill?: string;
  eyeFill?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="341 188 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M579.33 305.92C596.41 294.39 607.65 274.85 607.65 252.69C607.65 217.24 578.92 188.51 543.47 188.51C520.53 188.51 500.46 200.58 489.11 218.69L384.4 220.93L479.3 252.92C479.38 275.02 490.62 294.49 507.69 305.97C460.69 321.12 426.67 365.17 426.67 417.21C426.67 481.78 479.01 534.12 543.58 534.12C608.15 534.12 660.49 481.78 660.49 417.21C660.49 365.12 626.4 321.03 579.33 305.92Z"
        fill={fill}
      />
      <path
        d="M528.33 254.27C535.228 254.27 540.82 248.678 540.82 241.78C540.82 234.882 535.228 229.29 528.33 229.29C521.432 229.29 515.84 234.882 515.84 241.78C515.84 248.678 521.432 254.27 528.33 254.27Z"
        fill={eyeFill}
      />
      <g clipPath="url(#clip0_30_2)">
        <path
          d="M541 588C487.957 588 437.086 566.929 399.579 529.421C362.071 491.914 341 441.043 341 388L741 388C741 441.043 719.929 491.914 682.421 529.421C644.914 566.929 594.043 588 541 588Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_30_2">
          <rect
            width="400"
            height="200"
            fill="white"
            transform="translate(341 388)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
